import { Box, theme } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Calendar } from '@factorialco/f0-react/icons/app'
import Envelope from '@factorialco/f0-react/icons/app/Envelope'
import Share from '@factorialco/f0-react/icons/app/Share'

import i18n from 'modules/core/lib/i18n'

interface ModalFooterProps {
  onGetInfoByEmail: () => void
  onLearnMore: () => void
  onBookMeeting?: () => void
  hasMeetingLink?: boolean
}

export const ModalFooter = ({
  onGetInfoByEmail,
  onLearnMore,
  onBookMeeting,
  hasMeetingLink,
}: ModalFooterProps) => (
  <Box
    flexDirection="row"
    justifyContent="spaceBetween"
    alignItems="center"
    gap="s12"
    paddingTop="s16"
    paddingBottom="s16"
    paddingLeft="s12"
    paddingRight="s12"
    style={{
      flexShrink: '0',
      borderTop: `1px solid ${theme.colors.grey200}`,
    }}
  >
    <F0Button
      label={i18n.t('growth.product_modal_extended.get_info_by_email')}
      onClick={onGetInfoByEmail}
      variant="ghost"
      size="md"
      icon={Envelope}
    />
    <Box flexDirection="row" gap="s12">
      {hasMeetingLink && onBookMeeting ? (
        <F0Button
          label={i18n.t('growth.product_modal_extended.book_a_meeting')}
          onClick={onBookMeeting}
          variant="outline"
          size="md"
          icon={Calendar}
        />
      ) : null}
      <F0Button
        label={i18n.t('growth.product_modal_extended.learn_more')}
        onClick={onLearnMore}
        variant="default"
        size="md"
        icon={Share}
      />
    </Box>
  </Box>
)
